import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { ScheduledDifferentialRateDto } from '../facility-billable-rate/facility-billable-rate.dto';

export interface CorporateDefaultBillableRateDto {
  corporationId?: string; // format: uuid
  corporationName?: string;
  scopeOfPractice?: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay?: string;
  hourlyRate?: number; // format: double
  urgentHourlyRate?: number; // format: double
  isActive?: boolean;
  scheduledRates?: CorporateScheduledBillableRateDto[];
  id?: string; // format: uuid
  createdAt?: string; // format: date-time
  updatedAt?: string; // format: date-time
  differentialRate?: number; // format: double
  isDifferentialModified?: boolean;
  totalRate?: number; // format: double
  totalUrgentRate?: number; // format: double
  isBaseRateOverridden?: boolean;
  scheduledDifferentialRates?: ScheduledDifferentialRateDto[]; // Present when isDifferentialModified === false; contains active and future global differential snapshots
}

export interface CorporateScheduledBillableRateDto {
  corporateDefaultBillableRateId?: string; // format: uuid
  rate?: number; // format: double
  effectiveFrom?: string; // format: date-time
  effectiveTo?: string; // format: date-time
  id?: string; // format: uuid
  createdAt?: string; // format: date-time
  updatedAt?: string; // format: date-time
}
